import { acceptanceDateField } from '../../../shared/cards/complianceUpstreamFields';
import type { CoverSheetConfigCard } from '../../../types';

export const importantDatesCard = {
  id: 'propertyInfo.importantDates',
  innerTitle: 'Important Offer Date',
  legend: '',
  layout: [
    [
      {
        name: 'contractDate',
        size: 33,
      },
      { name: 'acceptanceDate', size: 33 },
    ],
  ],
  fields: {
    contractDate: {
      name: 'contractDate',
      entity: 'interaction',
      type: 'date',
      label: 'Contract Date',
      placeholderText: '',
    },
    acceptanceDate: acceptanceDateField,
  },
} satisfies CoverSheetConfigCard;
